<div *ngIf="this.featuresData" class="feature-div">
    <div *ngFor="let feature of this.featuresData">
        <div class="feature-title" [class.no-csv]= "!isPoint(feature)" (click)="feature.cardExpansed = !feature.cardExpansed">
           <custom-pin *ngIf="isPoint(feature)" class="csv-pin" [class.selected-pin]="feature.selected" [height]="feature.selected ? 27 : 20" [width]="feature.selected ? 20 : 13" [fillColor]="feature.style ? feature.style.fillColor: this.getFillColorLayer()"></custom-pin>
            <mat-icon>
                {{feature.cardExpansed ? 'arrow_drop_down' : 'arrow_right'}}
            </mat-icon>
            <div class="feature-name">{{feature.layerName}}</div>
        </div>
        <div *ngIf="feature.cardExpansed">
            <ng-container  *ngFor="let header of feature.headers">
                <div class="property-div">
                    <div class="property-key">{{header}}</div>
                    <div class="property-value">{{feature.properties[header]}}</div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
